import React, { useState, useEffect, useCallback } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Web3 from "web3";
import { abi } from "./contract/abi/ERC20Abi.json";

import { ThemeProvider } from "@material-ui/core/styles";
import { useWeb3React, UnsupportedChainIdError } from "@web3-react/core";
import { InjectedConnector } from "@web3-react/injected-connector";
import SnackbarContent from "@material-ui/core/SnackbarContent";

import "./App.css";
import Layout from "./components/Layouts/Default/Layout";

import { Web3ReactProvider } from "@web3-react/core";

import { getLibrary } from "./utils/getLibrary";
import ConnectWallet from "./components/ConnectWallet";

import CssBaseline from "@material-ui/core/CssBaseline";
import { darkTheme, lightTheme } from "./theme/materialUiTheme";
import { useSelector } from "react-redux";
import ProjectRegistration from "./containers/ProjectRegistration";
import KolRegistration from "./containers/KolRegistration";

import Landing from "./pages/Landing";
import DashboardLayoutRoutes from "./components/Layouts/Dashboard/DashboardLayoutRoutes";
import Dashboard from "./components/Dashboard";
import ManageFunds from "./containers/ManageFunds";

import DefaultLayoutRoutes from "./components/Layouts/Default/DefaultLayoutRoutes";
import TokenPoolRequirementForm from "./containers/TokenPoolRequirementForm";
import SearchTokenPools from "./containers/SearchTokenPools";

import ProgressHub from "./containers/ProgressHub";
import ProgressHubKolOverview from "./containers/ProgressHubKolOverview";
import ProgressHubKolDetails from "./containers/ProgressHubKolDetails";
import FormLayoutRoutes from "./components/Layouts/form/FormLayoutRoutes";
import ProtectedRouteKol from "./components/Layouts/ProtectedRouteKol";
import ProtectedRouteProject from "./components/Layouts/ProtectedRouteProject";

console.warn = () => {};

function App() {
  const isUser = useSelector((state) => state.ui.isUser);

  console.log('USER==========================',isUser)

  return (
    <Web3ReactProvider getLibrary={getLibrary}>
      <CssBaseline />
      <ThemeProvider theme={lightTheme}>
        <Router>
          <Layout>
            <ConnectWallet />

            <Switch>
              <DefaultLayoutRoutes exact path="/" component={Landing} />
              {!isUser.project && !isUser.kol && (
                <Switch>
                  <FormLayoutRoutes
                    exact
                    path="/registration"
                    component={ProjectRegistration}
                  />

                  <FormLayoutRoutes
                    exact
                    path="/kol-registration"
                    component={KolRegistration}
                  />

                  <Redirect to="/"/>
                </Switch>
              )}
              {isUser.project && (
                <Switch>
                  <DashboardLayoutRoutes
                    exact
                    path="/createtokenpool"
                    component={TokenPoolRequirementForm}
                  />
                  <DashboardLayoutRoutes
                    exact
                    path="/progresshub"
                    component={ProgressHub}
                  />
                  <DashboardLayoutRoutes
                    exact
                    path="/dashboard"
                    component={Dashboard}
                  />
                  <DashboardLayoutRoutes
                    exact
                    path="/managefunds"
                    component={ManageFunds}
                  />
                  <Redirect to="/dashboard"/>
                </Switch>
              )}

              {isUser.kol && (
                <Switch>
                  <DashboardLayoutRoutes
                    exact
                    path="/dashboard"
                    component={Dashboard}
                  />
                  <DashboardLayoutRoutes
                    exact
                    path="/search-token-pools"
                    component={SearchTokenPools}
                  />

                  <DashboardLayoutRoutes
                    exact
                    path="/progresshuboverview"
                    component={ProgressHubKolOverview}
                  />
                  <DashboardLayoutRoutes
                    exact
                    path="/progresshubdetails"
                    component={ProgressHubKolDetails}
                  />
                  <DashboardLayoutRoutes
                    exact
                    path="/managefunds"
                    component={ManageFunds}
                  />
                  <Redirect to="/dashboard"/>
                </Switch>
              )}
            </Switch>
          </Layout>
        </Router>
      </ThemeProvider>
    </Web3ReactProvider>
  );
}

export default App;
